import { CONFIG } from "@/config";
import { createClient } from "@hey-api/client-fetch";

export const authClient = createClient({
  baseUrl: CONFIG.AUTH_SERVER,
  credentials: "include",
});
